<div class="section-header">
	<div>
		<h2>Info</h2>
		Confirm patient information and demographics
	</div>

	<button mat-stroked-button (click)="savePatient()">Save</button>
</div>

<div class="input-section">
	<div class="title">
		Demographics
	</div>

	<div class="fields">
		<div class="row">
			<mat-form-field>
				<mat-label>First Name</mat-label>
				<input matInput [(ngModel)]="patient.first_name">
			</mat-form-field>

			<mat-form-field>
				<mat-label>Middle Name</mat-label>
				<input matInput [(ngModel)]="this.patientInfo.data[SurveyQuestions.MiddleName]">
			</mat-form-field>

			<mat-form-field>
				<mat-label>Last Name</mat-label>
				<input matInput [(ngModel)]="this.patient.last_name">
			</mat-form-field>
		</div>

		<div class="row">
			<mat-form-field>
				<mat-label>Preferred Name</mat-label>
				<input matInput [(ngModel)]="this.patientInfo.data[SurveyQuestions.PreferredName]">
			</mat-form-field>

			<mat-form-field>
				<mat-label>Primary Language</mat-label>
				<mat-select [(ngModel)]="this.patientInfo.data[SurveyQuestions.PrimaryLanguage]">
					<mat-option value="ENGLISH">English</mat-option>
					<mat-option value="SPANISH">Spanish</mat-option>
				</mat-select>
			</mat-form-field>
		</div>

		<div class="row">
			<mat-form-field>
				<mat-label>Date of birth</mat-label>
				<input matInput [(ngModel)]="patient.birthdate" [matDatepicker]="picker">
				<mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
				<mat-datepicker #picker></mat-datepicker>
			</mat-form-field>

			<mat-form-field>
				<mat-label>Age</mat-label>
				<input matInput disabled [value]="age">
			</mat-form-field>

			<mat-form-field>
				<mat-label>Sex</mat-label>
				<mat-select [(ngModel)]="patient.sex">
					<mat-option value="MALE">Male</mat-option>
					<mat-option value="FEMALE">Female</mat-option>
				</mat-select>
			</mat-form-field>
		</div>

		<div class="row">
			<mat-form-field>
				<mat-label>Race</mat-label>
				<mat-select [(ngModel)]="patient.race">
					<mat-option value="WHITE">White</mat-option>
					<mat-option value="BLACK_OR_AFRICAN_AMERICAN">Black or African American</mat-option>
					<mat-option value="AMERICAN_INDIAN_OR_ALASKA_NATIVE">American Indian or Alaska Native</mat-option>
					<mat-option value="ASIAN">Asian</mat-option>
					<mat-option value="NATIVE_HAWAIIAN_OR_OTHER_PACIFIC_ISLANDER">Native Hawaiian or Other Pacific Islander
					</mat-option>
					<mat-option value="OTHER">Other</mat-option>
				</mat-select>
			</mat-form-field>

			<mat-form-field>
				<mat-label>Ethnicity</mat-label>
				<mat-select [(ngModel)]="patient.ethnicity">
					<mat-option value="HISPANIC">Hispanic</mat-option>
					<mat-option value="NON_HISPANIC">Non Hispanic</mat-option>
				</mat-select>
			</mat-form-field>

			<mat-form-field>
				<mat-label>Marital status</mat-label>
				<mat-select [(ngModel)]="this.patientInfo.data[SurveyQuestions.MaritalStatus]">
					<mat-option value="MARRIED">Married</mat-option>
					<mat-option value="SINGLE">Single</mat-option>
					<mat-option value="DIVORCED">Divorced</mat-option>
					<mat-option value="WIDOWED">Widowed</mat-option>
				</mat-select>
			</mat-form-field>
		</div>
	</div>
</div>

<div class="input-section">
	<div class="title">Contact</div>

	<div class="fields">
		<div class="row">
			<mat-form-field>
				<mat-label>Email</mat-label>
				<input matInput [(ngModel)]="patient.email">
			</mat-form-field>
		</div>

		<div class="row">
			<mat-form-field>
				<mat-label>Cell phone</mat-label>
				<input matInput [(ngModel)]="patient.phone">
			</mat-form-field>
		</div>

		<div class="row">
			<mat-form-field>
				<mat-label>Work phone</mat-label>
				<input matInput [(ngModel)]="this.patientInfo.data[SurveyQuestions.WorkPhone]">
			</mat-form-field>

			<mat-form-field>
				<mat-label>Home phone</mat-label>
				<input matInput [(ngModel)]="this.patientInfo.data[SurveyQuestions.HomePhone]">
			</mat-form-field>
		</div>

		<div class="row">
			<mat-form-field>
				<mat-label>Street address</mat-label>
				<input matInput [(ngModel)]="this.patientInfo.data[SurveyQuestions.Address]">
			</mat-form-field>
		</div>

		<div class="row">
			<mat-form-field>
				<mat-label>City</mat-label>
				<input matInput [(ngModel)]="this.patientInfo.data[SurveyQuestions.City]">
			</mat-form-field>

			<mat-form-field>
				<mat-label>State</mat-label>
				<input matInput [(ngModel)]="this.patientInfo.data[SurveyQuestions.State]">
			</mat-form-field>

			<mat-form-field>
				<mat-label>Zip</mat-label>
				<input matInput [(ngModel)]="this.patientInfo.data[SurveyQuestions.Zip]">
			</mat-form-field>
		</div>
	</div>
</div>

<div class="input-section">
	<div class="title">Emergency & Care Contacts</div>

	<div class="fields">
		<div class="row">
			<mat-form-field>
				<mat-label>Emergency contact name</mat-label>
				<input matInput [(ngModel)]="this.patientInfo.data[SurveyQuestions.EmergencyContactName]">
			</mat-form-field>
		</div>

		<div class="row">
			<mat-form-field>
				<mat-label>Emergency contact phone</mat-label>
				<input matInput [(ngModel)]="this.patientInfo.data[SurveyQuestions.EmergencyContactNumber]">
			</mat-form-field>

			<mat-form-field>
				<mat-label>Emergency contact relationship</mat-label>
				<mat-select [(ngModel)]="this.patientInfo.data[SurveyQuestions.EmergencyContactRelationship]">
					<mat-option value="SPOUSE">Spouse</mat-option>
					<mat-option value="PARENT">Parent</mat-option>
					<mat-option value="CHILD">Child</mat-option>
					<mat-option value="OTHER">Other</mat-option>
				</mat-select>
			</mat-form-field>
		</div>

		<div class="row">
			<mat-form-field>
				<mat-label>Primary care physician</mat-label>
				<input matInput [(ngModel)]="this.patientInfo.data[SurveyQuestions.PrimaryCarePhysician]">
			</mat-form-field>
		</div>
	</div>
</div>

<div class="input-section">
	<div class="title">Responsible Party</div>

	<div class="fields">
		<div class="row">
			<mat-form-field>
				<mat-label>Responsible party</mat-label>
				<mat-select [(ngModel)]="this.patientInfo.data[SurveyQuestions.ResponsibleParty]" (selectionChange)="checkResponsibleParty($event.value)">
					<mat-option value="SELF">Self</mat-option>
					<mat-option value="OTHER">Other</mat-option>
				</mat-select>
			</mat-form-field>
		</div>

		<div class="row">
			<mat-form-field>
				<mat-label>Responsible party name</mat-label>
				<input matInput [(ngModel)]="this.patientInfo.data[SurveyQuestions.ResponsiblePartyName]" [disabled]="this.patientInfo.data[SurveyQuestions.ResponsibleParty] === 'SELF'">
			</mat-form-field>

			<mat-form-field>
				<mat-label>Responsible party relationship</mat-label>
				<mat-select [(ngModel)]="this.patientInfo.data[SurveyQuestions.ResponsiblePartyRelationship]" [disabled]="this.patientInfo.data[SurveyQuestions.ResponsibleParty] === 'SELF'">
					<mat-option value="SPOUSE">Spouse</mat-option>
					<mat-option value="PARENT">Parent</mat-option>
					<mat-option value="CHILD">Child</mat-option>
					<mat-option value="OTHER">Other</mat-option>
				</mat-select>
			</mat-form-field>
		</div>
	</div>
</div>
